//subForumInfo.js 获取分会议列表接口
import request from '@/utils/request';

export function getSubForum(forum_id) {
  return request({
    url: '/v1/forum_info/' + forum_id + '/sub_forum_info',
    method: 'get',
  });
}
